import TagPageReducer from './TagPageReducer';

export default from './TagPageContainer';

export const TagPageReducers = {
  TagPageReducer,
};
